import { getString } from "../common/common";

export const WLCM_KSRTC = "WLCM_KSRTC";
export const SRA = "SRA";
export const ENG = "ENG";
export const KND = "KND";
export const MY_ACC = "MY_ACC";
export const CMTR_LGN = "CMTR_LGN";
export const OP = "OP";
export const FRANCHISEE = "FRANCHISEE";
export const EMAIL = "EMAIL";
export const TYB1 = "TYB1";
export const TYB2 = "TYB2";
export const MITRA = "MITRA";
export const HOME = "HOME";
export const BE = "BE";
export const CT = "CT";
export const CBT = "CBT";
export const PT = "PT";
export const FU = "FU";
export const CO = "CO";
export const LO = "LO";
export const MY = "MY";
export const AC = "AC";

export const translations = {
  en: {
    [WLCM_KSRTC]: "Welcome to KSRTC",
    [SRA]: "Screen Reader Access",
    [ENG]: "English",
    [KND]: "Kannada",
    [MY_ACC]: "My Account",
    [CMTR_LGN]: "Commuter Login",
    [OP]: "Operator",
    [FRANCHISEE]: "Franchisee",
    [EMAIL]: "Email",
    [TYB1]: "Track",
    [TYB2]: "Your Bus",
    [MITRA]: "Mitra",
    [HOME]: "Home",
    [BE]: "Booking Enquiry",
    [CT]: "Cancel Ticket",
    [CBT]: "Cancel Bus Ticket",
    [PT]: "Package Tours",
    [FU]: "Follow us:",
    [CO]: "Commuter",
    [LO]: "Login",
    [MY]: "My",
    [AC]: 'Account',
  },
  kn: {
    [WLCM_KSRTC]: "ಕೆಎಸ್ಆರ್ಟಿಸಿಗೆ ಸುಸ್ವಾಗತ",
    [SRA]: "ಸ್ಕ್ರೀನ್ ರೀಡರ್ ಪ್ರವೇಶ",
    //[ENG]: "ಇಂಗ್ಲೀಶ್",
    [ENG]: "ಇಂಗ್ಲಿಷ್",
    [KND]: "ಕನ್ನಡ",
    [MY_ACC]: "ನನ್ನ ಖಾತೆ",
    [CMTR_LGN]: "ಪ್ರಯಾಣಿಕರ ಲಾಗಿನ್",
    [OP]: "ಆಪರೇಟರ್",
    [FRANCHISEE]: "ಫ್ರಾಂಚೈಸಿ",
    [EMAIL]: "ಇಮೇಲ್",
    [TYB1]: "ನಿಮ್ಮ",
    [TYB2]: "ಬಸ್‍ನ್ನು ಗುರುತಿಸಿ",
    [MITRA]: "ಮಿತ್ರ",
    [HOME]: "ಮುಖಪುಟ",
    [BE]: "ಬುಕಿಂಗ್ ವಿಚಾರಣೆ",
    [CT]: "ಟಿಕೇಟ್ ರದ್ಧತಿ",
    [CBT]: "ಬಸ್ ಟಿಕೆಟ್ ರದ್ದುಗೊಳಿಸಿ",
    [PT]: "ಪ್ಯಾಕೇಜ್ ಪ್ರವಾಸಗಳು",
    [FU]: "ನಮ್ಮನ್ನು ಫಾಲೋ ಮಾಡಿ:",
    [CO]: "ಪ್ರಯಾಣಿಕರ",
    [LO]: "ಲಾಗ್‍ಇನ್",
    [MY]: "ನನ್ನ",
    [AC]: "ಖಾತೆ"
  },
};

export const t = (key = "") => {
  return getString(key, translations)
}